function getVfsPath(data) {
    const path = data?.params?.path ?? data?.params?.home ?? data?.data?.path ?? data?.data?.home;
    if (!path) {
        return undefined;
    }
    return encodeURIComponent(path);
}

export default getVfsPath;
